import { useTranslate } from './useTranslate.js';

export interface TranslateProps {
  children: string;
}

export const Translate: React.FC<TranslateProps> = ({ children }) => {
  const translate = useTranslate();
  // i18n-extract-disable
  return <>{translate(children)}</>;
};
